import AppBody from "../../components/AppBody";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import CreateCategoryModel from "./CreateCategoryModel";
import { categoryList } from "../../../actions/admin/certification/category_action";

const CategoryPage = () => {
  const state = useSelector((state) => state.categoryReducer);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(categoryList());
  }, []);

  const [show, setPopShow] = useState(false);
  const [categoryData, setCategoryData] = useState({});
  const [is_action, setIsAction] = useState(1);
  const handelClick = () => {
    setPopShow(true);
  };
  const handelClosePopup = () => {
    setPopShow(false);
    setCategoryData({});
    setIsAction(1);
    dispatch(categoryList());
  };

  const editCategory = (li) => {
    setCategoryData(li);
    setPopShow(true);
    setIsAction(2);
  };

  return (
    <AppBody
      loading={state.loading}
      content={
        <div className="middle-sidebar-left">
          <div className="">
            <div className="card">
              <div className="card-header p-3 w-100 border-0 d-flex rounded-lg">
                <h4 className="font-xs text-white fw-600 mb-0 mt-2">
                  Category
                </h4>
                <div className="col text-right pr-0">
                  <button
                    type="button"
                    name="submit"
                    value="Add Category"
                    className="line-height-36 custom-icon mr-2"
                    title="Create Certification"
                    onClick={() => handelClick()}
                  >
                    <i className="feather-plus-circle"></i>
                  </button>
                </div>
              </div>
              {show && (
                <CreateCategoryModel
                  show={show}
                  categoryData={categoryData}
                  isAction={is_action}
                  handelUpdateShow={() => handelClosePopup()}
                />
              )}
              <div className="card-body p-4 w-100 border-0 ">
                <div className="table-responsive">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th>Sr.No</th>
                        <th>Name</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {state.list &&
                        state.list.map((li, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{li.name}</td>
                            <td>
                              <input
                                type="button"
                                title={"Edit"}
                                value={"Edit"}
                                onClick={() => editCategory(li)}
                                className="btn approve_btn btn-common"
                              />
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default CategoryPage;
